module.exports = __webpack_public_path__ + "static/media/capacity-left.5616fdc3.svg";